<template>
  <div class="page-session" v-if="is_sesstion">
    <div class="sesstion-center">
      <div class="sesstion-title">
        {{$t('thalIndex.t_21')}}<span class="sesstion-title-close" @click.stop="_sesstion_list(1)"><i class="el-icon-close"></i></span>
      </div>
      <div class="sesstion-item" v-if="recordlist.length>0">
        <div v-for="(item,index) in recordlist" @click.stop="_sesstion_list(2,item.record_id)">{{ item.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[1]+':'+item.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[2]}} {{ $t('thalIndex.t_9') }}</div>
      </div>
      <div class="sesstion-item" v-else><span>{{$t('thalIndex.t_22')}}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sesstion",
  props:['title'],
  data(){
    return{
      is_sesstion:false,
      record_id:'',
      lottery_id:'',
      lottery_name:'',
      is_hf:'',
      is_tally:'',
    }
  },
  methods:{
    _sesstion_list:function (m,id){
      let _self=this;
      if(m==1){
        _self.is_sesstion=false;
        _self.recordlist=[];
      }else if(m==2){
        _self.is_sesstion=false;

        if(_self.is_hf==1){
          this.$router.push({path:'/THAL/bet2D?is_hf='+_self.is_hf+'&lottery_id='+_self.lottery_id+'&record_id='+id+'&is_tally='+_self.is_tally+"&lottery_name="+_self.lottery_name})
        }else if(_self.is_hf==0){
          this.$router.push({path:'/THAL/bet3D?is_hf='+_self.is_hf+'&lottery_id='+_self.lottery_id+'&record_id='+id+'&is_tally='+_self.is_tally+"&lottery_name="+_self.lottery_name})
        }

      }

    },
    _record:function (){
      let _self=this;
      let is_show=1;
      this._PublicFun.getData('2', 'get', 'lottery/section/'+_self.lottery_id, {}, function (result) {
        if(result.data['status_code']==200){
          _self.recordlist=result.data['data'];
          if(_self.title=='bet'){
            _self.is_sesstion=true;
          }else if(_self.title=='record'){
            for(var i=0;i<_self.recordlist.length;i++){
              if(_self.record_id==_self.recordlist[i].record_id){
                _self._sesstion_list(2,_self.record_id);
                _self.is_show=2;
              }

            }
            if(is_show==1 && _self.title=='record'){
              _self.is_sesstion=true;
            }
          }




        }

      })
    },
  }
}
</script>



<style scoped>
.page-session{
  position: fixed;
  z-index: 999;
  left: 0;
  width: 100%;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
}
.sesstion-center{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #2D2D2D;
  border-radius: 5px;
  width: 80%;
  max-width: 600px;
}
.sesstion-title{
  display: block;
  width: 100%;
  text-align: center;
  padding: 15px 0;
  margin: 0 auto;
  color: #ffffff;
  position: relative;
}
.sesstion-title-close{
  position: absolute;
  right: 5px;
  color: #EDD185;
  top:50%;
  cursor: pointer;
  transform: translateY(-50%);
  font-size: 20px;
}
.sesstion-item{
  display: block;
  width: 90%;
  margin: 0 auto;
  padding: 0;
  text-align: center;

}
.sesstion-item span{
  display: block;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  color: #EDD185;
}
.sesstion-item div{
  display: block;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
  margin: 5px auto;
  padding: 8px 0;
  text-align: center;
  background-color: #EDD185;
}

</style>



// WEBPACK FOOTER //
// src/components/THAL/sesstion.vue